import { AfterViewInit, Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { IColumns } from 'bi-interfaces/lib/interfaces/IColumns.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IGridSteps } from 'bi-interfaces';
import {
  AddEvent,
  CancelEvent,
  CellClickEvent,
  CellCloseEvent,
  GridComponent,
  GridDataResult,
  RemoveEvent,
  SaveEvent,
} from "@progress/kendo-angular-grid";

@Component({
  selector: 'BI-GridSteps',
  templateUrl: './bi-grid-steps.component.html',
  styleUrls: ['./bi-grid-steps.component.scss']
})
export class BIGridStepsComponent implements OnInit, AfterViewInit, IGridSteps {

  @Input() GridData: any[] = [];
  @Input() Columns: IColumns[] = [];
  @Input() ColumnsKey!: string;
  @Input() GridId!: string;

  public RowDataChangeSubject$ = new Subject();
  public OrignalOrder: string = "";
  public IsDirty: boolean = false;
  public _DisableAll: boolean = false;
  constructor() {

  }
  ngOnInit(): void {
    this.GridData.map((el) => {
      this.OrignalOrder += el[this.ColumnsKey]

    })

  }
  ngAfterViewInit(): void {

  }

  changeCheckBox(currentRow: any, colName: string) {
    this.IsDirty = true;
    this.RowDataChangeSubject$.next({ currentRow, colName });
  }
  PopPendingChanges() {
    let dirtyData = ''
    this.GridData.map((el) => {
      dirtyData += el[this.ColumnsKey]

    })
    if (dirtyData != this.OrignalOrder || this.IsDirty) {
      this.IsDirty = false;
      this.OrignalOrder = dirtyData;
      return true;

    }
    return false;

  }

   DisableAll(value: boolean) {
    this._DisableAll = value;
  }

  FillOrignalOrder(GridData: any[]) {
    let Data = ''
    GridData.map((el) => {
      Data += el[this.ColumnsKey]
    });
    this.OrignalOrder = Data;
  }




  public cellClickHandler({ sender, rowIndex, column, columnIndex, dataItem, isEdited }: CellClickEvent): void {

  }
}
